import { ReactNode } from 'react'

const HeaderRow = ({ children }: { children: ReactNode }): JSX.Element => (
  <div className="px-3 d-flex align-items-center">{children}</div>
)

export default HeaderRow
